import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import classnames from "classnames";
import {
	Button,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	UncontrolledDropdown,
	NavbarBrand,
	Navbar,
	Container
} from "reactstrap";
import { MoreVertOutlined } from "@material-ui/icons";
import { logout } from 'core/redux-store/login/Actions';
import { connect } from 'react-redux';

class AdminNavbar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			collapseOpen: false,
			color: "navbar-transparent"
		};

		this.doLogout = this.doLogout.bind(this);
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateColor);
	}
	componentDidUpdate(e) {
		if (
			window.outerWidth < 993 &&
			e.history.location.pathname !== e.location.pathname &&
			document.documentElement.className.indexOf("nav-open") !== -1
		) {
			document.documentElement.classList.toggle("nav-open");
		}
	}

	doLogout() {
		this.props.dispatch(logout());
	}
	// function that adds color white/transparent to the navbar on resize (this is for the collapse)
	updateColor = () => {
		if (window.innerWidth < 993 && this.state.collapseOpen) {
			this.setState({
				color: "bg-white"
			});
		} else {
			this.setState({
				color: "navbar-transparent"
			});
		}
	};
	// this function opens and closes the sidebar on small devices
	toggleSidebar = () => {
		document.documentElement.classList.toggle("nav-open");
	};
	// this function opens and closes the collapse on small devices
	// it also adds navbar-transparent class to the navbar when closed
	// ad bg-white when opened
	toggleCollapse = () => {
		let newState = {
			collapseOpen: !this.state.collapseOpen
		};
		if (!this.state.collapseOpen) {
			newState["color"] = "bg-white";
		} else {
			newState["color"] = "navbar-transparent";
		}
		this.setState(newState);
	};
	render() {

		return (<div/>)
		// return (
		// 	<>
		// 		<Navbar
		// 			className={classnames("navbar-absolute fixed-top no-print", this.state.color)}
		// 			expand="lg"
		// 		>
		// 			<Container fluid>
		// 				<div className="navbar-wrapper">
		// 					<div className="navbar-minimize">
		// 						<Button
		// 							className="btn-icon btn-round"
		// 							color="default"
		// 							id="minimizeSidebar"
		// 							onClick={this.props.handleMiniClick}
		// 						>
		// 							<i className="nc-icon nc-minimal-right text-center visible-on-sidebar-mini" />
		// 							<i className="nc-icon nc-minimal-left text-center visible-on-sidebar-regular" />
		// 						</Button>
		// 					</div>
		// 					<div
		// 						className={classnames("navbar-toggle", {
		// 							toggled: this.state.sidebarOpen
		// 						})}
		// 					>
		// 						<button
		// 							className="navbar-toggler"
		// 							type="button"
		// 							onClick={this.toggleSidebar}
		// 						>
		// 							<span className="navbar-toggler-bar bar1" />
		// 							<span className="navbar-toggler-bar bar2" />
		// 							<span className="navbar-toggler-bar bar3" />
		// 						</button>
		// 					</div>
		// 					<div className="title-navbar">Nome da tela</div>
		// 					{/* <NavbarBrand onClick={e => e.preventDefault()}>
		// 						<span className="d-md-block">
		// 							<Breadcrumb>
		// 								<BreadcrumbItem>
		// 									<GroupSelection />
		// 								</BreadcrumbItem>
		// 							</Breadcrumb>
		// 						</span>
		// 					</NavbarBrand> */}
		// 				</div>
		// 				<UncontrolledDropdown className="btn-rotate">
		// 					<DropdownToggle
		// 						aria-haspopup={true}
		// 						caret={false}
		// 						color="default"
		// 						data-toggle="dropdown"
		// 						id="navbarDropdownMenuLink"
		// 						nav
		// 					>
		// 						<MoreVertOutlined />
		// 					</DropdownToggle>
		// 					<DropdownMenu aria-labelledby="navbarDropdownMenuLink" right>
		// 						<DropdownItem
		// 							onClick={this.doLogout}
		// 						>
		// 							Sair
		// 						</DropdownItem>
		// 					</DropdownMenu>
		// 				</UncontrolledDropdown>
		// 			</Container>
		// 		</Navbar>
		// 	</>
		// );
	}
}

export default connect()(AdminNavbar);

/* Search Button 
<Form>
                <InputGroup className="no-border">
                  <Input defaultValue="" placeholder="Search..." type="text" />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i className="nc-icon nc-zoom-split" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Form>
*/
